var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('clip-loader',{staticStyle:{"display":"flex","justify-content":"center","align-items":"center","height":"100%"},attrs:{"size":"70px","color":_vm.color}})}
var staticRenderFns = []

export { render, staticRenderFns }